'use client';

import { Box, Button, Container, Grid, Typography } from '@mui/material';
import cx from 'clsx';

import { Link } from '@/i18n/navigation';
import colors from '@/styles/themes/colors';
import { Solution, SolutionColor } from '@/types/solution.type';

import SolutionItem from './SolutionItem';
import styles from './SolutionsShowcaseSection.module.scss';

interface SolutionsShowcaseSectionProps {
  title: string;
  description: string;
  ctaText: string;
  ctaHref?: string;
  solutions: Solution[];
  color?: SolutionColor;
}

const SolutionsShowcaseSection = ({
  title,
  description,
  ctaText,
  ctaHref = '/contact',
  solutions,
  color = 'blue',
}: SolutionsShowcaseSectionProps) => (
  <Container
    maxWidth={false}
    disableGutters
    component="section"
    className={cx(styles.containerWrapper, styles[`color${color.charAt(0).toUpperCase()}${color.slice(1)}`])}
  >
    <Container maxWidth="xl" className={styles.container}>
      <Grid container spacing={{ xs: 8, lg: 3 }}>
        <Grid size={{ xs: 12, lg: 6 }} order={{ xs: 1, lg: 2 }} className={styles.stickyContainer}>
          <Typography variant="h2" color={colors.white} fontWeight={500}>
            {title}
          </Typography>
          <Typography variant="body1" color={colors.graytone200} marginTop={2}>
            {description}
          </Typography>
          <Button component={Link} href={ctaHref} variant="contained" sx={{ mt: 3 }}>
            {ctaText}
          </Button>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }} order={{ xs: 2, lg: 1 }}>
          <Box className={styles.solutionsList}>
            {solutions.map(solution => (
              <SolutionItem key={solution.title} solution={solution} color={color} />
            ))}
          </Box>
        </Grid>
      </Grid>
    </Container>
  </Container>
);

export default SolutionsShowcaseSection;
